import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';
import aplCatlCode from '@/json/aplCatlCode';
import codeList from '@/json/codeList';

const code = codeList.ACH;
const aplCatl = aplCatlCode.ACH;

export const routesACH = [
    {
        path: 'auth-methods',
        name: routeName.AUTH_METHODS,
        component: () => import('@/views/aplCatlACH/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '申請金融機構轉帳電子化繳費授權', leaveAlert: false, code, pageTitle: '申請金融機構轉帳電子化繳費授權', unableBack: false },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.HOME, routeName.SSO_PAGE, routeName.SSO_SCV, routeName.SSO_MOBILE];
            const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
            next(guideRoute);
        },
    },
    {
        path: 'auth-account',
        name: routeName.AUTH_ACCOUNT,
        component: () => import('@/views/aplCatlACH/authAccount/Index.vue'),
        meta: { auth: true, metaTitle: '金融機構轉帳電子化繳費授權帳戶', leaveAlert: true, code, pageTitle: '申請金融機構轉帳電子化繳費授權', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.AUTH_TERMS, routeName.CONFIRM_DATA];
            const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
            next(guideRoute);
        },
    },
    {
        path: 'auth-terms',
        name: routeName.AUTH_TERMS,
        component: () => import('@/views/aplCatlACH/authTerms/Index.vue'),
        meta: { auth: true, metaTitle: '金融機構轉帳電子化繳費授權說明', leaveAlert: true, code, pageTitle: '申請金融機構轉帳電子化繳費授權', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.AUTH_POLICY];
            const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
            next(guideRoute);
        },
    },
    {
        path: 'auth-policy',
        name: routeName.AUTH_POLICY,
        component: () => import('@/views/aplCatlACH/authPolicy/Index.vue'),
        meta: { auth: true, metaTitle: '選擇金融機構轉帳電子化繳費授權之保單', leaveAlert: true, code, pageTitle: '申請金融機構轉帳電子化繳費授權', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.AUTH_METHODS, routeName.CONFIRM_DATA, routeName.FINISH];
            const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
            next(guideRoute);
        },
    },
    {
        path: 'auth-reading',
        name: routeName.AUTH_READING,
        component: () => import('@/views/aplCatlACH/authReading/Index.vue'),
        meta: { auth: true, metaTitle: '金融機構轉帳電子化繳費授權傳送中', leaveAlert: true, code, pageTitle: '申請金融機構轉帳電子化繳費授權', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.CONFIRM_DATA];
            const guideRoute = guideRoutes(from, whiteList, false, aplCatl);
            next(guideRoute);
        },
    },
];
